import React from 'react';
import { useTranslation } from 'react-i18next';
import SafeImage from '../utils/SafeImage';

export default function LinkGrid({ title, links = [] }) {
    const { t } = useTranslation();
    if (!links || links.length === 0) return null;

    return (
        <div>
            {title && <h2 className="section-title mb-4">{title}</h2>}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {links.map((link, i) => (
                    <div key={i} className="card overflow-hidden">
                        {link.imageUrl && (
                            <div className="h-36 overflow-hidden">
                                <SafeImage
                                    src={link.imageUrl}
                                    alt={link.title}
                                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                                />
                            </div>
                        )}
                        <div className="p-4 flex flex-col gap-2">
                            {link.title   && <h4 className="font-bold text-gray-900 dark:text-gray-100">{link.title}</h4>}
                            {link.summary && <p className="text-sm text-gray-600 dark:text-gray-400">{link.summary}</p>}
                            {link.url && (
                                <a
                                    href={link.url}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block btn-primary text-sm text-center mt-1"
                                >
                                    {t('common.visitLink')}
                                </a>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
